import { Typography } from '@mui/material';

export default function HeadingBlock({ block }: { block: any }) {
    return (
        <Typography
          variant={`h${block.level}` as
            | "h1"
            | "h2"
            | "h3"
            | "h4"
            | "h5"
            | "h6"}
          sx={{
            color: "white",
            fontWeight: block.style === "b" ? "bold" : undefined,
            mb: block.mb != undefined ? block.mb : 2,
            fontSize: block.level === 4 ? "clamp(22px, 2.5vw, 28px)" : undefined,
          }}
        >
          {block.text}
        </Typography>
    );
}